import { Link } from "react-router-dom";
import { connaissancesRubriques } from "../data/connaissances";

// Renvoie une accroche courte tirée du début de l'intro du sujet.
function buildAccroche(intro) {
  if (!intro) return "";
  const cleaned = intro.replace(/\s+/g, " ").trim();
  if (cleaned.length <= 160) return cleaned;
  const cut = cleaned.slice(0, 160);
  const lastSpace = cut.lastIndexOf(" ");
  return `${cut.slice(0, lastSpace > 0 ? lastSpace : cut.length)}...`;
}

export default function Connaissances() {
  return (
    <div
      className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16"
      data-testid="connaissances-page"
    >
      {/* Hero */}
      <header className="mb-12" data-testid="connaissances-hero">
        <span className="hej-chip" data-testid="connaissances-chip">
          <span className="w-1.5 h-1.5 rounded-full bg-[#DC143C]"></span>
          Mis à jour en juin 2026
        </span>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight mt-4">
          Connaissances sur la Pologne
        </h1>
        <p className="text-slate-600 mt-4 leading-relaxed text-lg">
          Pour s'installer dans un pays, il aide d'en comprendre les codes, l'histoire et l'actualité. Cette rubrique rassemble des
          séries de questions courtes, regroupées par thème, pour tester ce que vous savez déjà et découvrir le reste.
        </p>
      </header>

      {/* Rubriques */}
      <div className="space-y-16" data-testid="connaissances-rubriques">
        {connaissancesRubriques.map((rubrique) => (
          <section
            key={rubrique.id}
            id={rubrique.id}
            className="scroll-mt-24"
            data-testid={`rubrique-${rubrique.id}`}
          >
            <h2 className="font-display text-2xl sm:text-3xl font-semibold text-slate-900 mb-2">
              {rubrique.titre}
            </h2>
            {rubrique.description ? (
              <p className="text-slate-600 leading-relaxed mb-6">
                {rubrique.description}
              </p>
            ) : null}

            {rubrique.sujets.length > 0 ? (
              <ul
                className="space-y-4"
                data-testid={`rubrique-${rubrique.id}-sujets`}
              >
                {rubrique.sujets.map((sujet) => (
                  <li key={sujet.id}>
                    <Link
                      to={`/fr/connaissances/${rubrique.id}/${sujet.id}`}
                      className="block rounded-xl border border-slate-200 bg-white p-5 transition hover:border-slate-300 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-400"
                      data-testid={`sujet-link-${rubrique.id}-${sujet.id}`}
                    >
                      <span className="block font-display text-lg sm:text-xl font-semibold text-slate-900">
                        {sujet.titre}
                      </span>
                      {sujet.intro ? (
                        <span className="block text-slate-600 text-sm leading-relaxed mt-2">
                          {buildAccroche(sujet.intro)}
                        </span>
                      ) : null}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <p
                className="text-slate-400 italic text-sm"
                data-testid={`rubrique-${rubrique.id}-empty`}
              >
                Bientôt
              </p>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}
